import { Link, useLocation } from 'react-router-dom'
import { ActionReturnStyle } from './styles'
import { KeyboardArrowLeft } from '@mui/icons-material'
import { Button } from '@mui/material'
import { translate } from '../../../../../i18n/index'
import { findCategory } from 'presentation/utils/helpers/helpers'

export type ParamsTypeProps = {
  title?: string
  slug?: string
  route?: string
}

export type HeaderStepsProps = {
  params?: ParamsTypeProps
}

const ActionReturn = ({ params }: HeaderStepsProps) => {
  const location = useLocation()
  const items = findCategory(location.pathname)

  return <ActionReturnStyle>
    <Button
      variant="outlined"
      startIcon={<KeyboardArrowLeft style={{ color: '#495057', fontSize: 16 }} />}
      component={Link}
      to={params?.route || items[0].route}
    >
      {translate('labelRetornar')}
    </Button>
  </ActionReturnStyle>
}

export default ActionReturn
